// Pure helper for the Port Calendar's selection-update logic.
// Extracted from store.tsx::setPortsSelected so the order-preservation
// + identity-on-no-change semantics are testable in isolation.
//
// Returns the SAME reference as `current` when nothing actually
// changes — Solid's store treats setStore(same-ref) as a no-op, so
// preserving identity here avoids spurious reactive triggers on
// idempotent toggles (e.g. selecting an already-selected port, or
// deselecting a port that wasn't selected).

export function applySelection(
  current: readonly string[],
  ports: readonly string[],
  selected: boolean,
): readonly string[] {
  if (ports.length === 0) return current;
  if (selected) {
    const have = new Set(current);
    const fresh: string[] = [];
    for (const p of ports) {
      if (!have.has(p)) {
        have.add(p); // dedup against the incoming batch too
        fresh.push(p);
      }
    }
    return fresh.length === 0 ? current : [...current, ...fresh];
  }
  const drop = new Set(ports);
  const filtered = current.filter((p) => !drop.has(p));
  return filtered.length === current.length ? current : filtered;
}
